import { stripTags } from '@/components/utils/common';

function DOMLoaded() {
	console.info('Step1JS-DOMLoaded()');

	const searchBox = document.querySelector('.live-search-box');
	
	if (searchBox) {
		searchBox.addEventListener('keyup', function(e) {
			if (e.key === 'Enter') { // 엔터
				e.preventDefault();
				return false;
			}
		});
	
		// 실시간 검색
		searchBox.addEventListener('keyup', function() {
			const searchTerm = this.value ? this.value.toLowerCase() : ''; // null 체크
			let live_data_cnt = 0;
	
			document.querySelectorAll('.paginationTable .tableItem').forEach(function(item) {
				const dataSearchTerm = item.getAttribute('data-search-term');
				if (dataSearchTerm && dataSearchTerm.toLowerCase().includes(searchTerm) || searchTerm.length < 1) {
					item.setAttribute("data-show", "Y");
					item.style.display = "flex"; // 적절한 display 속성 사용
					live_data_cnt++;
				} else {
					item.setAttribute("data-show", "N");
					item.style.display = "none";
				}
			});
	
			const nomatch_list = document.querySelector(".nomatch_list");
	
			if (nomatch_list) {
				if (live_data_cnt > 0) {
					nomatch_list.style.display = 'none';
				} else {
					nomatch_list.style.display = 'flex';
				}
			}
	
			//page_set();
	
			if (this.value.replace(/\s/g, "").length === 0) {
				return false;
			}
		});
	} else {
		console.error('Element with class .live-search-box not found');
	}
	
	// 240725 안씀 확인
	/*
	document.addEventListener("click", function(e) {
		if (e.target && e.target.classList.contains("chk_btn")) {
			if (document.querySelectorAll(".match_list .tableItem.select").length !== 1) {
				alert("AI 기공주문서를 작성할 치과 또는 기공소를 선택해주세요.");
				return false;
			}
			return true;
		}
	});
	*/

	// 240725 commonjs에서 여기로 옮김
	/*
	const registBtn = document.querySelector("#set_lab1 .regist_btn");
	if (registBtn) {
		registBtn.addEventListener('click', function () {
			document.documentElement.style.overflow = 'hidden';
			document.body.style.overflow = 'hidden';
			document.querySelector('#match_ok').style.display = 'block';
			document.querySelector('.modal_bg').style.display = 'block';
		});
	}
	*/
/*
	const matchOkNo = document.querySelector("#match_ok .no");
	if (matchOkNo) {
		matchOkNo.addEventListener('click', function () {
			const scr = window.scrollY;
			document.documentElement.style.overflow = 'auto';
			document.body.style.overflow = 'auto';
			window.scrollTo(0, scr);
			document.querySelector('#match_ok').style.display = 'none';
			document.querySelector('.modal_bg').style.display = 'none';
		});
	}
*/

/*
	// 이벤트 위임을 위해 checkbox-container에 이벤트 리스너 추가
	const match_r = document.querySelector(".r_hospital_list");
		if (match_r) {
			match_r.addEventListener('click', function(event) {
			if (event.target && event.target.type === 'checkbox') {
				if (!event.target.checked) {
					const mb_id = event.target.value;
					// r목록에서 삭제
					event.target.closest('li').remove();

					// r등록버튼 숨김
					const checkboxes = document.querySelectorAll(".r_hospital_list input[type='checkbox']:not([disabled])");
					const count = checkboxes.length;
					if (count < 1) {
						const registBtn = document.querySelector("#set_lab1 .regist_btn");
						if (registBtn) {
							registBtn.style.display = 'none';
						}
					}

					// 상대편 전체 목록
					const HZwrapper = 'paginationTable'; // wrapper class
					const listItem = document.querySelector(`.${HZwrapper} li[data-id='${mb_id}']`);
					listItem.style.removeProperty('color');
					listItem.querySelector("div.select_btn1").style.display = "block";
					listItem.querySelector("div.select_btn2").style.display = "none";
					listItem.querySelector("div.select_btn2").textContent = "매칭 요청";

					// matchok
					document.querySelector(`#confirm_hospital_list li[data-id='${mb_id}']`).remove();
					const partner_cnt = Number(document.querySelectorAll(".confirm_hospital_count")[0].textContent);
					document.querySelectorAll(".confirm_hospital_count").forEach(cnt => { cnt.textContent = partner_cnt-1});
				}
			}
		});
	}
*/
}

function add_list(mb_boss_id, mb_nick, mb_addr, mb_tel) {
	const HZwrapper = 'paginationTable'; // wrapper class
	const template = document.getElementById("add_list_template").innerHTML;

//console.log(template);

	// 순차적으로 replace 메서드 호출
	const html = template // stripTags함수 제거
		.replace(/\[\[mb_boss_id\]\]/gi, mb_boss_id)
		.replace(/\[\[mb_nick\]\]/gi, mb_nick)
		.replace(/\[\[mb_addr\]\]/gi, mb_addr != 'null' ? mb_addr : '')
		.replace(/\[\[mb_tel\]\]/gi, mb_tel);

//console.log(html);

	const container = document.querySelector(".r_hospital_list");
	container.insertAdjacentHTML('beforeend', html);

	const listItem = document.querySelector(`.${HZwrapper} li[data-id='${mb_boss_id}']`);
	listItem.style.color = "#ccc";
	listItem.querySelector("div.select_btn1").style.display = "none";
	listItem.querySelector("div.select_btn2").style.display = "block";
	listItem.querySelector("div.select_btn2").textContent = "선택 완료";
	//page_set();

	const confirmTemplate = document.getElementById("confirm_hospital_list_template").innerHTML;
	const confirmHtml = confirmTemplate // stripTags함수 제거
		.replace(/\[\[mb_boss_id\]\]/gi, mb_boss_id)
		.replace(/\[\[mb_nick\]\]/gi, mb_nick)
		.replace(/\[\[mb_addr\]\]/gi, mb_addr != 'null' ? mb_addr : '')
		.replace(/\[\[mb_tel\]\]/gi, mb_tel);

	document.getElementById("confirm_hospital_list").insertAdjacentHTML('beforeend', confirmHtml);
	const partner_cnt = Number(document.querySelectorAll(".confirm_hospital_count")[0].textContent);
	document.querySelectorAll(".confirm_hospital_count").forEach(cnt => { cnt.textContent = partner_cnt+1});

	const registBtn = document.querySelector("#set_lab1 .regist_btn");
	if (registBtn) {
		registBtn.style.display = 'block';
	}
}

const hospital_check = (event, mb_id, mb_nick, mb_addr, mb_tel) => {
	const checkbox = event.target;

	if (!checkbox.checked) {
		document.querySelectorAll(`input[type='checkbox'][value='${mb_id}']`).forEach(checkbox => {
			checkbox.checked = false;
		});
		const listItem = document.querySelector(`#confirm_hospital_list li[data-id='${mb_id}']`);
		if (listItem) listItem.remove();
		document.querySelectorAll(".confirm_hospital_count")[0].textContent -= 1;
	} else {
		document.querySelectorAll(`input[type='checkbox'][value='${mb_id}']`).forEach(checkbox => {
			checkbox.checked = true;
		});

		const template = document.querySelector("#confirm_hospital_list_template").innerHTML;
		const html = stripTags(template)
			.replace(/\[\[mb_id\]\]/gi, mb_id)
			.replace(/\[\[mb_nick\]\]/gi, mb_nick)
			.replace(/\[\[mb_addr\]\]/gi, mb_addr)
			.replace(/\[\[mb_tel\]\]/gi, mb_tel);

		document.querySelector("#confirm_hospital_list").insertAdjacentHTML('beforeend', html);
		const partner_cnt = Number(document.querySelectorAll(".confirm_hospital_count")[0].textContent);
		document.querySelectorAll(".confirm_hospital_count").forEach(cnt => { cnt.textContent = partner_cnt+1});
	}
};

export { DOMLoaded, add_list, hospital_check };